import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TiposServicio } from '../model/tipo-servicio';

@Injectable()
export class TipoServicioService {

  constructor(private http: HttpClient) { }

  private API_TIPO_SERVICIO = environment.API_BASE + '/Services/GetTypes/{ID_CLIENTE}';

  getServicesType(idCliente: number, serviceName: string): Observable<TiposServicio> {
    return this.http.get<TiposServicio>(this.API_TIPO_SERVICIO.replace('{ID_CLIENTE}', idCliente.toString() + '/' + serviceName))
      .pipe(map((tiposServicio: TiposServicio) => TiposServicio.toModel(JSON.stringify(tiposServicio))));
  }
}
